'use client'

import { Container } from '@mui/material'
import { useState } from 'react'

import Introduction from '@/features/home/Introduction'
import SelectLanguage from '@/features/home/SelectLanguage'

export default function Home() {
  const [pageNumber, setPageNumber] = useState(0)

  return (
    <Container
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100svh',
        px: 0,
      }}
    >
      {pageNumber === 0 && (
        <SelectLanguage
          setPageNumber={(page: number) => {
            setPageNumber(page)
          }}
        />
      )}
      {pageNumber === 1 && <Introduction />}
    </Container>
  )
}
